import { useEffect, useRef, CSSProperties } from "react";
import * as echarts from 'echarts';
import { EChartsOption, ECharts } from "echarts";

export default function ChartCanvas({ options, styles }: {
    options?: EChartsOption;
    styles?: CSSProperties;
}) {
    const containerRef = useRef(null);
    const chartRef = useRef<ECharts>(null);
    useEffect(() => {
        setTimeout(() => {
            if (containerRef.current && options) {
                (chartRef.current as any) = chartRef.current || echarts.init(containerRef.current, 'dark');
                (chartRef.current as ECharts).setOption(options);
            }
        }, 0);
    }, [options]);
    return <div ref={containerRef} style={{ ...styles }}></div>
}